import React from "react";

const Input = (props) => {
  const customProps = props?.customProps || {};

  return (
    <input
      {...props}
      className={`w-full rounded-md py-2 px-5 bg-gray-800 text-lg text-white placeholder-white::placeholder ${props?.className}`}
      {...customProps}
    />
  );
};

export default Input;
